import type { ModalProps as AntModalProps } from 'antd';
import Modal from './Modal';
import { Row } from '../Box';
import { Text } from '../Text';
import { IcClose } from 'basic-ui-lib/icons';
import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Button } from '../Button';
interface ModalProps extends AntModalProps {
  title: string;
  className?: string;
  closeOnClickOutside?: boolean;
  isOpen?: boolean;
  width?: string | number;
  onClose?: () => void;
  hiddenFooter?: boolean;
  isMobile?: boolean;
  disabled?: boolean;
}

const BaseModal = ({ title, className, closeOnClickOutside, isOpen, width, children, onClose, okText, onOk, hiddenFooter = false, isMobile = false, disabled }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} title={title} className={className} closeOnClickOutside={closeOnClickOutside} width={width}>
      <Header>
        <Text title_h5 semibold>{title}</Text>
        {!isMobile && (
          <ButtonClose onClick={onClose}>
            <IcClose />
          </ButtonClose>
        )}
      </Header>
      {children}
      {!hiddenFooter && (
        isMobile ? (
          <FooterMobileActions>
            <Button type_cancel lg onClick={onClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg onClick={onOk} style={{ width: '100%' }}>
              {okText || 'Confirm'}
            </Button>
          </FooterMobileActions>
        ) : (
          <FooterActions>
            <Button type_second lg onClick={onOk} disabled={disabled}>
              {okText || 'Confirm'}
            </Button>
          </FooterActions>
        )
      )}
    </Modal>
  );
};

export default BaseModal;

const Header = styled(Row)`
  padding: 24px;
  justify-content: center;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 16px;

    .title_h5 {
      font-size: 18px;
    }
  }
`;

const FooterActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-top: 1px solid ${Colors.neutral.border[1]};

  .type_second {
    min-width: 240px;
  }
`;

const ButtonClose = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
`;

const FooterMobileActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 16px;
  gap: 16px;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.15);
`;